import React, { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import { CardContent, FormControl, FormControlLabel, FormHelperText, Switch } from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSelect from "../../../../components/MasterSelect";
import { useLocation, useNavigate } from "react-router-dom";
import ImageUpload from "../../../../components/UploadImage";

export const GeneralInsurerForm = ({ editInsurerData, onsubmit }) => {

  const companyTypeOptions = [
    { value: "Life Insurance", label: "Life Insurance" },
    { value: "Health Insurance", label: "Health Insurance" },
    { value: "Motor Insurance", label: "Motor Insurance" },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const isEditPage = location.pathname.includes("/edit-insurer");
  const [insurerData, setInsurerData] = useState({
    // insurer information
    companyName: "",
    companyCode: "",
    companyType: "",
    websiteUrl: "",
    sortOrder: "",
    logo: null,
    active: true,

    // insurer information status
    companyNameStatus: "unchecked",
    companyCodeStatus: "unchecked",
    companyTypeStatus: "unchecked",
    websiteUrlStatus: "unchecked",
    sortOrderStatus: "unchecked",
  });
  const [logoPreview, setLogoPreview] = useState(null);


  useEffect(() => {
    if (editInsurerData) {
      setInsurerData(editInsurerData);
    }
  }, [editInsurerData]);

  const handleInsurerDataChange = (event, selectEvent) => {
    let insurerState = { ...insurerData };

    const changeAllowed = true;

    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "companyType":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              insurerState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              insurerState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      insurerState[selectEvent.name] = event;
      
    } else if (event) {
      switch (event.target.name) {
        case "companyName":
          {
            const alphaNLenghthRegex = new RegExp("^([\\s\\S]{2,40})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
                insurerState[event.target.name + "Status"] = "success";
            } else {
                insurerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "companyCode":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 -/:;@.#&]{2,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
                insurerState[event.target.name + "Status"] = "success";
            } else {
                insurerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "websiteUrl":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 -/:;@.#&]{2,100})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
                insurerState[event.target.name + "Status"] = "success";
            } else {
                insurerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "sortOrder":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
                insurerState[event.target.name + "Status"] = "success";
            } else {
                insurerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

          case "active":
          {
            const value = event.target.value;
            insurerState[event.target.name] = value;
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        insurerState[event.target.name] = event.target.value;
      }
    }
    setInsurerData(insurerState);
  };

  const handleImageChange = (file, name) => {
    setInsurerData((prevData) => ({
      ...prevData,
      [name]: file,
    }));
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      insurerData.companyNameStatus === "success" &&
      insurerData.companyCodeStatus === "success" &&
      insurerData.companyTypeStatus === "success" &&
      insurerData.websiteUrlStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(insurerData);
    }
  };

  return (
    <div>
      <CardContent sx={{ minHeight: "65vh" }}>
        <MaterialBox>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Insurance Company Name*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="companyName"
                placeholder="eg. HDFC General Insurance"
                value={insurerData.companyName}
                onChange={handleInsurerDataChange}
                error={insurerData.companyNameStatus === "error" ? true : false}
                success={insurerData.companyNameStatus === "success" ? true : false}
              />
              {insurerData.companyNameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Name should be maximum 40 characters long and can contain
                    only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            
            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Company Code*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="companyCode"
                placeholder="eg. HDFC"
                value={insurerData.companyCode}
                onChange={handleInsurerDataChange}
                error={insurerData.companyCodeStatus === "error" ? true : false}
                success={insurerData.companyCodeStatus === "success" ? true : false}
              />
              {insurerData.companyCodeStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Code should be maximum 20 characters long and can contain
                    only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Company Type*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="companyType"
                value={insurerData.companyType}
                customStyles={{ optionPadding: 20 }}
                onChange={handleInsurerDataChange} //selectedValue, event
                options={companyTypeOptions?.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={
                  insurerData.companyTypeStatus === "error" ? true : false
                }
                success={
                  insurerData.companyTypeStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Website Url*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="websiteUrl"
                placeholder="eg. www.hdfc.com"
                value={insurerData.websiteUrl}
                onChange={handleInsurerDataChange}
                error={insurerData.websiteUrlStatus === "error" ? true : false}
                success={insurerData.websiteUrlStatus === "success" ? true : false}
              />
              {insurerData.websiteUrlStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    URL should be maximum 100 characters long and can contain
                    only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Sort Order
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="number"
                name="sortOrder"
                placeholder="eg. 1"
                value={insurerData.sortOrder}
                onChange={handleInsurerDataChange}
                error={insurerData.sortOrderStatus === "error" ? true : false}
                success={insurerData.sortOrderStatus === "success" ? true : false}
              />
              {insurerData.sortOrderStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Sort Order should be maximum 20 characters long and can contain
                    only number
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Active
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="active"
                    checked={insurerData.active}
                    onChange={(event) =>
                      handleInsurerDataChange({
                        target: {
                          name: "active",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {insurerData?.active ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Insurance Company Logo
                </MaterialTypography>
                <ImageUpload
                  name={"logo"}
                  onImageUpload={handleImageChange}
                  imageProps={logoPreview}
                />
              </MaterialBox>
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
      <MaterialBox display="flex" justifyContent="space-between" alignItems="center">
        <MaterialButton
          sx={{ m: 2 }}
          variant="outlined"
          color="dark"
          onClick={() => {
            navigate("/general-master/general-insurer");
          }}
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          sx={{ m: 2 }}
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleSubmit}
        >
          {isEditPage ? "Update" : "Submit"}
        </MaterialButton>
      </MaterialBox>
    </div>
  );
};
